import type { IconData } from '@stacksjs/iconify-core'

export const otherArrowsSynchronize: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 8V0l-2.343 2.343A7.98 7.98 0 0 0 8 0C5.79 0 3.79.895 2.343 2.343l2.829 2.829C5.895 4.448 6.895 4 8 4s2.105.448 2.828 1.172L8 8H0v8l2.343-2.343A7.98 7.98 0 0 0 8 16c2.21 0 4.21-.895 5.657-2.343l-2.829-2.829A4 4 0 0 1 8 12a4 4 0 0 1-2.828-1.172L8 8z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherArrowsSynchronize
